export const ScrollToTopMixin = {
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
